import { createIcon } from '@chakra-ui/icons';

export const FacebookIcon = createIcon({
  displayName: 'FacebookIcon',
  viewBox: '0 0 32 32',
  path: [
    <path
      key="1"
      d="M32 16.001C32 7.16445 24.8366 0.0010128 16 0.0010128C7.16344 0.0010128 0 7.16445 0 16.001C0 23.9871 5.85097 30.6063 13.5 31.8066V20.626H9.4375V16.001H13.5V12.476C13.5 8.46601 15.8887 6.25101 19.5434 6.25101C21.294 6.25101 23.125 6.56351 23.125 6.56351V10.501H21.1074C19.1198 10.501 18.5 11.7344 18.5 12.9997V16.001H22.9375L22.2281 20.626H18.5V31.8066C26.149 30.6063 32 23.9871 32 16.001Z"
      fill="#1877F2"
    />,
    <path
      key="2"
      d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7333 19.1198 10.5 21.1074 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8887 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.3146 31.9334 15.1495 32 16 32C16.8505 32 17.6854 31.9334 18.5 31.8056V20.625H22.2281Z"
      fill="white"
    />,
  ],
});
